import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getWeatherIcon } from '../../constants/weatherCodes';

const HourlyForecast = ({ weather }) => {
  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <h3 className="font-semibold text-lg mb-4 dark:text-gray-100">📊 24-Hour Forecast</h3>
      <div className="overflow-x-auto">
        <div className="flex gap-3 pb-2" style={{ minWidth: '600px' }}>
          {weather?.hourly?.time && (() => {
            const now = new Date();
            const currentHour = now.getHours();
            // Find the index of the current hour
            const currentHourIndex = weather.hourly.time.findIndex(time => {
              const hourDate = new Date(time);
              return hourDate.getHours() === currentHour && 
                     hourDate.getDate() === now.getDate();
            });
            const startIndex = currentHourIndex >= 0 ? currentHourIndex : 0;
            
            return weather.hourly.time.slice(startIndex, startIndex + 24).map((time, idx) => {
              const hour = new Date(time);
              const isNow = idx === 0;
            
              return (
                <div 
                  key={idx} 
                  className={`flex-shrink-0 text-center p-3 rounded-lg ${
                    isNow ? 'bg-orange-100 dark:bg-orange-900/30 border border-orange-300 dark:border-orange-700' : 
                    'bg-gray-50 dark:bg-gray-700/50'
                  }`}
                  style={{ minWidth: '80px' }}
                >
                  <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
                    {isNow ? 'Now' : hour.toLocaleTimeString('en-US', { hour: 'numeric' })}
                  </p>
                  <p className="text-2xl my-2">
                    {getWeatherIcon(weather.hourly.weather_code?.[startIndex + idx] ?? 0)}
                  </p>
                  <p className="font-bold text-lg dark:text-gray-100">
                    {Math.round(weather.hourly.temperature_2m?.[startIndex + idx] ?? 0)}°
                  </p>
                  {weather.hourly.precipitation_probability?.[startIndex + idx] !== undefined && (
                    <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                      {weather.hourly.precipitation_probability[startIndex + idx]}% 💧
                    </p>
                  )}
                  {weather.hourly.wind_speed_10m?.[startIndex + idx] !== undefined && (
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {Math.round(weather.hourly.wind_speed_10m[startIndex + idx])} mph
                    </p>
                  )}
                </div>
              );
            });
          })()}
        </div>
      </div>
    </div>
  );
};

HourlyForecast.propTypes = {
  weather: PropTypes.shape({
    hourly: PropTypes.shape({
      time: PropTypes.arrayOf(PropTypes.string),
      temperature_2m: PropTypes.arrayOf(PropTypes.number),
      weather_code: PropTypes.arrayOf(PropTypes.number),
      precipitation_probability: PropTypes.arrayOf(PropTypes.number),
      wind_speed_10m: PropTypes.arrayOf(PropTypes.number)
    })
  })
};

export default memo(HourlyForecast);